@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
<div class="projectable-form-wrapper"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
  >
  <lib-form-header
    [data]="formData"
    [title]="formData.id ? 'Edit SCIM Integration: ' : 'Create New SCIM Integration'"
    [moreActions]="moreActions"
    (actionRequested)="headerActionRequested($event)"
    [(formView)]="formView"
  ></lib-form-header>
  <div class="integration-form-container projectable-form-container">
    @if (formView === 'simple') {
      <div class="projectable-form-main-column form-group-row">
        <div class="form-group-column three-fifths">
          <lib-form-field-container [title]="'Integration Name'" [label]="errMap['name'] ? 'INVALID' : 'REQUIRED'">
            <input
              class="form-field-input"
              placeholder="Name this SCIM Integration"
              [ngClass]="{error: errMap['name'] || errMap['nameRequired']}"
              [(ngModel)]="formData.name"
              autofocus
              #nameFieldInput
              />
          </lib-form-field-container>
          @if (isEditing) {
            <lib-form-field-container [showHeader]="false"
              >
              <lib-scim-integration-url-copy
                [baseUrl]="svc.integrationClientUrl"
                [integrationKey]="formData.integrationKey"
              ></lib-scim-integration-url-copy>
            </lib-form-field-container>
          }
          <ng-content select="[slot=column-1-slot-1]"></ng-content>
          <lib-update-scim-mapping-config
            [integrationId]="entityId"
            [showUpdateMappingConfig]="'(isEditing && valueMappings.size > 0)'"
            [showApply]="'true'"
            [save]="saveSubject"
            (wasUpdated)="mappingConfigUpdateHandler($event)"
          ></lib-update-scim-mapping-config>
        </div>
        <div class="form-group-column two-fifths">
          <ng-content select="[slot=column-2-slot-1]"></ng-content>
          <lib-form-field-container [showHeader]="false">
            @if (isEditing) {
              <lib-scim-integration-auth
                [integrationId]="entityId"
                [jwtConnectionId]="formData.jwtConnectionId"
                [serviceIdentityId]="formData.serviceIdentityId"
                >
              </lib-scim-integration-auth>
            }
          </lib-form-field-container>
        </div>
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData"></lib-json-view>
        }
      </div>
    }

  </div>
